<script setup>
import {ErrorMessage, Field} from "vee-validate"

const model = defineModel()

const props = defineProps({
  label: {
    type: String,
    default: '',
  },
  inputId: {
    type: String,
    default: () => ('id' + Math.floor(Math.random() * 100000) + 1)
  },
  name: {
    type: String,
    default: () => ('name_' + Math.floor(Math.random() * 100000) + 1)
  },
  disabled: {
    type: Boolean,
    default: false
  },
  help: {
    type: String,
    default: ''
  },
  offValue: {
    type: [Boolean, String, Number],
    default: false
  },
  onValue: {
    type: [Boolean, String, Number],
    default: true
  }
})

</script>

<template>
  <div class="text-md italic">
    <div class="flex justify-start items-center">
      <Field
        :id="props.inputId"
        :name="props.name"
        type="checkbox"
        v-model="model"
        :value="props.onValue"
        :unchecked-value="props.offValue"
        :disabled="props.disabled"
        class="mr-2 cursor-pointer"
      />
      <label :for="props.id">
        <slot>
          {{ props.label}}
        </slot>
      </label>
    </div>
    <ErrorMessage :name="props.name" class="text-xs col-span-12 text-red-800 text-right mt-1"/>
  </div>
</template>
